<template>

    <input-autocomplete
            v-bind="getInputProps({
            onSelect: onAutocompleteSelect,
            onKeyDown: onInputWrite,
            disableBlur: preventBlur,
            strictSelection: true,
            autocompleteOnVoid: false,
            defaultLoading: loading,
            defaultAutocompleteList: autocompleteList,
            autocompleteHandler: fetchAutocomplete,
            iconRight: iconRightClass,
            iconLoading: '',
            onIconRightClick: getCurrentLocation
        })"

            v-model="inputValue"
            ref="input"
    >
        <template #hidden="{ autocompleteList, selected, dropdownShow }">
            <slot
                    name="hidden"
                    v-bind="{ autocompleteList, selected, selectedPlace, location, address, lat, lng, city, description,  dropdownShow }"
            >
            </slot>
        </template>
        <template #next="{ autocompleteList, selected, dropdownShow }">
            <slot
                    name="next"
                    v-bind="{ autocompleteList, selected, selectedPlace, location, address, lat, lng, city, description, dropdownShow }"
            >
            </slot>
        </template>
        <template #prev="{ autocompleteList, selected, dropdownShow }">
            <slot
                    name="prev"
                    v-bind="{ autocompleteList, selected, selectedPlace, location, address, lat, lng, city, description, dropdownShow }"
            >
            </slot>
        </template>
    </input-autocomplete>

</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinMapsService from './mixinMapsService';
    import mixinInput from './mixinInput';

    import InputAutocomplete from './InputAutocomplete';

    const {props} = InputAutocomplete;

    export default {
        mixins: [mixinCommon, mixinMapsService, mixinInput],

        components: {
            'input-autocomplete': InputAutocomplete
        },
        props: {
            ...props,
            defaultLocation: {
                type: Object,
                default: () => ({address: '', city: '', lat: '', lng: '', description: ''})
            }
        },
        computed: {
            lastSelected() {
                return this.$refs.input.$data.selected;
            },
            autocompleteList() {
                return this.predictions.map(
                    (item) => {
                        const {description: text, place_id: id} = item;
                        return {
                            ...item,
                            id,
                            text
                        };
                    })
                    ;
            },

            location() {
                if (this.selectedPlace) {
                    const address = this.getAddress(this.selectedPlace);
                    const city = this.getCity(this.selectedPlace);
                    const {lat, lng} = this.getLatLng(this.selectedPlace);
                    const description = (this.lastSelected)?this.lastSelected.description:address;

                    return {
                        address,
                        city,
                        lat,
                        lng,
                        description
                    };
                } else {
                    return this.defaultLocation;
                }
            },
            address() {
                const {address = ''} = this.location || {};
                return address;
            },
            city() {
                const {city = ''} = this.location || {};
                return city;
            },
            lat() {
                const {lat = ''} = this.location || {};
                return lat;
            },
            lng() {
                const {lng = ''} = this.location || {};
                return lng;
            },
            description() {
                const {description = ''} = this.location || {};
                return description;
            }
        },

        data() {
            return {
                preventBlur: false,

                waitingBlur: false,

                selectedPlace: null,
                predictions: [],
                iconRightClass: '',//'fa fa-spinner fa-pulse text-primary cursor-pointer',
            };
        },
        watch: {
            /*serviceLoading(isLoading) {
                if (isLoading)
                    this.iconRightClass = 'fa fa-spinner fa-pulse text-primary';
                else if( document.location.protocol.indexOf('https') < 0 || !window.navigator.geolocation)
                    this.iconRightClass = 'fa fa-map-marker text-danger';
                else {
                    this.iconRightClass = 'fa fa-map-marker text-primary cursor-pointer';
                }
                this.loading = !!+isLoading;
            }*/
        },
        mounted() {
            /*if (this.defaultLocation.address === '') {
                (async () => {
                    await this.onLoadingGmap();
                    this.getCurrentLocation();

                })();
            }*/
        },
        methods: {
            async fetchAutocomplete(query = this.inputValue) {
                this.predictions = await this.fetchPredictions(query);

                if (this.waitingBlur) {
                    this.preventBlur = false;
                    this.waitingBlur = false;

                    setTimeout(() => {
                        this.blur();
                    }, 0);
                }

                return this.predictions;
            },

            async onAutocompleteSelect(item) {
                const {text: address, place_id: placeId} = item || {};

                this.selectedPlace = await this.geocode({placeId});
            },

            onInputWrite(evt) {
                this.preventBlur = true;
                switch (evt.which) {
                    case 13 :
                        evt.preventDefault();
                        this.waitingBlur = true;
                        break;
                }

            },

            getInputProps(overrideProps = {}) {
                return this.getComponentProps(InputAutocomplete, overrideProps);
            },

            async getCurrentLocation() {
                this.getGeolocation(response => {
                    this.reverseGeocode(response, (result) => {
                        if (!result) return false;
                        this.selectedPlace = result;
                        this.inputValue = this.address;
                    });
                })
            }
        }
    };
</script>
